import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { updateMeProfile } from '@/api/services/auth.service'
import { getErrorMessage } from '@/lib/getErrorMessage'
import { useAuthStore } from '@/stores/useAuthStore'
import { meQueryKey } from './useMe'
import type { UpdateMePayload } from '@/types/user.types'

export function useUpdateMe() {
  const queryClient = useQueryClient()
  const setUser = useAuthStore((s) => s.setUser)

  return useMutation({
    mutationFn: (payload: UpdateMePayload) => updateMeProfile(payload),
    onSuccess: (data) => {
      queryClient.setQueryData(meQueryKey, data)
      setUser((current) =>
        current
          ? {
              ...current,
              firstName: data.firstName,
              lastName: data.lastName,
              name: [data.firstName, data.lastName].filter(Boolean).join(' ') || current.email,
            }
          : current
      )
      // The current user's name also renders in admin lists.
      queryClient.invalidateQueries({ queryKey: ['users'] })
      queryClient.invalidateQueries({ queryKey: ['companies', 'members', 'workspace'] })
      toast.success('Profile updated')
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    },
  })
}
